export enum EStatusItemLoteEnum {
  INCLUIDO = "Incluido",
  EM_VALIDACAO = "Em validação",
  VALIDO = "Válido",
  INVALIDO = "Inválido",
  EM_PROCESSAMENTO = "Processando pagamento",
  AGUARDANDO_REPROCESSAMENTO = "Aguardando processamento",
  PROCESSADO_COM_FALHA = "Erro",
  ERRO = "Erro",

  CRIANDO_CADASTRO = "Criando cadastro",
  CRIANDO_CONTA = "Criando cadastro",
  CRIANDO_CARTAO = "Criando cartão",
  CRIANDO_ACESSO = "Criando acesso",
  ERRO_CADASTRO = "Erro cadastro",
  ERRO_CONTA = "Erro cadastro",
  ERRO_CARTAO = "Erro cartão",
  ERRO_ACESSO = "Erro acesso",
  PROCESSADO_COM_SUCESSO = "Cadastrado com sucesso",
}

function getStatusColor(status: EStatusItemLoteEnum): string {
  switch (status) {
    case EStatusItemLoteEnum.INCLUIDO:
    case EStatusItemLoteEnum.EM_VALIDACAO:
    case EStatusItemLoteEnum.EM_PROCESSAMENTO:
    case EStatusItemLoteEnum.AGUARDANDO_REPROCESSAMENTO:
      return "#EEB03D";
    case EStatusItemLoteEnum.INVALIDO:
    case EStatusItemLoteEnum.PROCESSADO_COM_FALHA:
    case EStatusItemLoteEnum.ERRO:
    case EStatusItemLoteEnum.ERRO_CARTAO:
    case EStatusItemLoteEnum.ERRO_CONTA:
    case EStatusItemLoteEnum.ERRO_CADASTRO:
    case EStatusItemLoteEnum.ERRO_ACESSO:
      return "#DC3545"; // Cor de erro
    case EStatusItemLoteEnum.VALIDO:
    case EStatusItemLoteEnum.PROCESSADO_COM_SUCESSO:
      return "#05A660"; // Cor de sucesso
    default:
      return "#007BFF"; // Cor padrão para "criando"
  }
}

export const StatusItemLoteMap = Object.keys(EStatusItemLoteEnum).reduce(
  (map, key) => {
    const status = key as keyof typeof EStatusItemLoteEnum;
    map[status] = {
      label: EStatusItemLoteEnum[status],
      color: getStatusColor(EStatusItemLoteEnum[status]),
    };
    return map;
  },
  {} as Record<
    keyof typeof EStatusItemLoteEnum,
    { label: string; color: string }
  >
);
